/**
 * Namespace `tingeeConnections` — PLAT-2026-112: kết nối Tingee của mọi công ty bên bube-banktransfer, trạng thái đăng ký
 * webhook theo VA + quét lần đầu, nút « Đăng ký lại ». Chỉ dev — dashboard của khách không có (người dùng chốt 2026-10-14).
 */
export const tingeeConnections = {
  title: "Kết nối Tingee — webhook theo VA",
  intro:
    "Khi một kết nối Tingee có hiệu lực, bube-banktransfer tự đăng ký webhook THEO VA với Tingee rồi quét 10 ngày giao dịch. Đây là nơi xem kết quả và gửi lại khi lỗi. Số VA đã che.",
  loading: "Đang đọc kết nối…",
  loadFailed: "Không đọc được kết nối Tingee.",
  empty: "Chưa có kết nối Tingee nào.",
  showDeleted: "Hiện cả kết nối đã xoá ({n})",
  allDeleted: "Không có kết nối đang dùng — {n} kết nối đã xoá đang ẩn.",
  truncated: "Chỉ hiện {limit} kết nối mới nhất.",
  refresh: "Tải lại",
  "col.company": "Công ty",
  "col.bank": "Ngân hàng · VA",
  "col.stage": "Trạng thái",
  "col.webhook": "Webhook",
  "col.scan": "Quét lần đầu",
  "stage.awaiting_bank_link": "Chờ liên kết ngân hàng",
  "stage.creating": "Đang tạo VA",
  "stage.awaiting_confirmation": "Chờ xác nhận OTP",
  "stage.awaiting_notify_confirmation": "Chờ xác nhận nhận biến động",
  "stage.active": "Đang hoạt động",
  "stage.awaiting_delete_confirmation": "Chờ xác nhận xoá",
  "stage.deleted": "Đã xoá",
  "stage.failed": "Thất bại",
  "mode.va": "VA",
  "mode.account": "STK gốc",
  "flow.create_va": "tạo VA",
  "flow.bank_link": "liên kết ngân hàng",
  "env.sandbox": "Sandbox",
  "env.live": "Live",
  unknownCompany: "(không còn công ty)",
  legacyLinkCode: "cờ « mã liên kết » cũ — tự về VA ở lượt đối soát kế",
  noVa: "chưa có VA",
  "webhook.subscribed": "Đã đăng ký",
  "webhook.failed": "Lỗi {code}",
  "webhook.skipped.link_code": "Bỏ qua · cờ « mã liên kết » cũ, chờ đối soát",
  "webhook.skipped.no_va": "Bỏ qua · chưa có VA",
  "webhook.never": "Chưa chạy",
  "webhook.meta": "{at} · {n} lượt",
  "scan.done": "Kéo {pulled} · tạo {created} ({days} ngày)",
  "scan.failed": "Lỗi {code}",
  "scan.skipped": "Bỏ qua",
  "scan.never": "Chưa quét",
  lastFailure: "Lỗi gần nhất: {code}",
  action: "Đăng ký lại…",
  notActive: "Chỉ gửi lại khi kết nối đã có hiệu lực.",
  writeOnly: "Cần quyền ghi bube-banktransfer để gửi lại.",
  "confirm.title": "Gửi lại đăng ký webhook?",
  "confirm.body":
    "Hub nhờ bube-banktransfer gọi Tingee bằng khoá của nền tảng, trỏ biến động số dư của VA {va} ({company}) về bube-banktransfer. Gọi lại kể cả khi đã đăng ký; ghi sổ kiểm toán.",
  "confirm.scan": "Quét lại 10 ngày giao dịch (idempotent — không tạo trùng)",
  "confirm.submit": "Gửi lại",
  "confirm.sending": "Đang gửi…",
  failed: "Không gửi lại được.",
  "result.subscribed": "Tingee nhận đăng ký.",
  "result.failed": "Tingee từ chối: {code}. Kết quả đã ghi vào dòng.",
  "result.skipped": "bube-banktransfer bỏ qua bước webhook ({reason}).",
} as const;
